import { render, staticRenderFns } from "./AvailableMiscs.vue?vue&type=template&id=3aaf12f6"
import script from "./AvailableMiscs.vue?vue&type=script&lang=js"
export * from "./AvailableMiscs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aaf12f6')) {
      api.createRecord('3aaf12f6', component.options)
    } else {
      api.reload('3aaf12f6', component.options)
    }
    module.hot.accept("./AvailableMiscs.vue?vue&type=template&id=3aaf12f6", function () {
      api.rerender('3aaf12f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/components/AvailableMiscs.vue"
export default component.exports